import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .RBReq': {
    '& p:not(last-child), ul': {
      marginBottom: theme.spacing(1.25),
    },
    '& ul p': {
      marginBottom: '0',
    },
  },
  '& .RBBenefit': {
    '& ul': {
      marginBottom: theme.spacing(1.75),
    },
  },
}));

export default StyledBox;
